import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=6657e930&scoped=true"
import script from "./Bookmarks.vue?vue&type=script&lang=ts"
export * from "./Bookmarks.vue?vue&type=script&lang=ts"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=6657e930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657e930",
  null
  
)

export default component.exports